module.exports = __webpack_public_path__ + "static/media/money-owed-from-friend-family.753707fe.svg";